import api from '../api/user/UserUserReq';
import { toast } from 'sonner'
import '../styles/main.css';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthProvider';
import { CiLogout } from "react-icons/ci";


const Logout = () => {

    const navigate = useNavigate();
    const { logout } = useAuth();

    const handleLogout = async () => {
        try {
            const response = await api.get('logout', {withCredentials: true});
            if (response.data.success) {
                logout();
                toast.success("Successfully logged out!")
                navigate('/flexp-login');
            } else {
                toast.error("Error! Something go wrong with logging out!")
                console.error("Undentified error");
            }
            
        } catch (error) {
            toast.error("Session was ended! You are not logged in!")
            console.log("Not authorized")
        }
    }

    return (
        <div className='logout-container'>
          <div className='logout-card'>
            <h2 className='logout-title'>Logout</h2>
            <button onClick={handleLogout} className='logout-button'><CiLogout /></button>
          </div>
        </div>
      );
    };

export default Logout;